// listing分析

const state = {
  analyseFormTabsId: '', // tabs的选择id
}

const mutations = {
  SET_ANALYSE_FORM_TABSID: (state, data) => {
    state.analyseFormTabsId = data
  },
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
